export default __webpack_public_path__ + "static/media/83_mobile.0728d6a3.jpg";